import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/certification_icon.png'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "login_wrap" }
const _hoisted_3 = {
  key: 0,
  class: "caps-lock-warning"
}

import { useRouter } from "vue-router";
import { userStore } from "@/store/userStore";
import authModal from "@/components/popup/authModal.vue";
import { onMounted, onUnmounted, ref } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const store = userStore();
const router = useRouter();
const login = ref(false);
const close = () => {
  login.value = false;
}
let interval
const hiddenInput = ref<HTMLInputElement>();
const capsLockOn = ref(false);
const checkCapsLock = (event?: KeyboardEvent) => {
  // event가 없으면 현재 상태를 유지
  if (!event) return;
  
  if (event.getModifierState && event.getModifierState("CapsLock")) {
    capsLockOn.value = true;
    clearInterval(interval); // 초기 확인 후 인터벌 정리
  } else {
    capsLockOn.value = false;
  }
};
const handlePageClick = () => {
  // 숨겨진 입력 필드에 포커스하여 Caps Lock 상태 확인
  if (hiddenInput.value) {
    hiddenInput.value.focus();
    
    // 포커스가 사용자에게 보이지 않도록 즉시 blur 처리
    setTimeout(() => {
      hiddenInput.value?.blur();
    }, 0);
  }
};
const handleKeyDown = (event: KeyboardEvent) => {
  checkCapsLock(event);
};

const goPage = (page: string) => {
  window.scrollTo({ top: 0, behavior: "auto" });
  router.push({ name: page });
};
onUnmounted(() => {
  login.value = false;
});
onMounted(() => {
  // 키보드 이벤트 리스너
  window.addEventListener("keydown", handleKeyDown);
  
  // 페이지 클릭 이벤트 리스너
  document.addEventListener("click", handlePageClick);
  
  // 페이지 로드 시 초기 확인 시도
  // 브라우저는 페이지 로드 시 Caps Lock 상태를 바로 알려주지 않으므로 
  // 사용자가 숨겨진 입력 필드에 포커스할 수 있도록 함
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "page_header" }, "로그인", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "page_header_line" }, null, -1)),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "description" }, [
        _createTextVNode(" 고객님께서 해당하는 회원의 종류를 선택해주세요."),
        _createElementVNode("br"),
        _createTextVNode(" 회원가입 후 최종 승인완료가 되면 정상적인 서비스 이용이 가능합니다."),
        _createElementVNode("br"),
        _createTextVNode(" 통합회원과 일반회원을 반드시 구분하여 가입하시기 바라며 로그인 시 자동으로 권한에 따라 컨텐츠가 구분됩니다. ")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("div", null, [
          _createElementVNode("img", { src: _imports_0 })
        ], -1)),
        _createElementVNode("div", {
          class: "login_btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (login.value = true)),
          style: {"position":"relative"}
        }, [
          _cache[2] || (_cache[2] = _createTextVNode("사용자 범용 인증서 ")),
          (capsLockOn.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Caps Lock이 켜져있습니다 "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "join_btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (goPage('signup')))
        }, "회원가입"),
        _createElementVNode("input", {
          ref_key: "hiddenInput",
          ref: hiddenInput,
          type: "text",
          style: {"position":"absolute","opacity":"0","pointer-events":"none"},
          onKeydown: handleKeyDown,
          onInput: checkCapsLock
        }, null, 544)
      ])
    ]),
    (login.value)
      ? (_openBlock(), _createBlock(authModal, {
          key: 0,
          onClose: close,
          businessno: ''
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})